import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Typography,
  Box,
} from "@mui/material";
import { styled } from "@mui/system";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    borderColor: '#d3d3d3',  
    borderTopWidth: 4,       
    borderRadius: 2,         
    top: '66px', 
    marginLeft: '-54px',
    marginRight: '-13px',
    position: 'relative'
  },
}));

const CustomStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: ownerState.active
    ? 'green' 
    // ? '#D9D9D9' 
    : ownerState.completed
    ? '#3BC97B' 
    : '#D9D9D9', 
  zIndex: 1,
  color: '#fff',
  width: 20,  
  height: 20, 
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  border: ownerState.active || ownerState.completed 
    ? '4px solid #d3d3d3'  
    : '4px solid #d3d3d3',  
  marginTop: '5px',
  position: 'relative',
  transition: 'all 0.4s ease-in-out',
  '&:hover': {
    backgroundColor: ownerState.active || ownerState.completed ? '#3BC97B' : '#B0B0B0',
    transform: 'scale(1.2)',
    cursor: 'pointer',
  },
}));
  
  function CustomStepIcon(props) {
    const { active, completed } = props;
  
    return (
      <CustomStepIconRoot ownerState={{ completed, active }}>
      </CustomStepIconRoot>
    );
  }

CustomStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const CustomStepWizard = ({ steps, current, onSubmit, initialStep = 0 }) => {
  const [currentStep, setCurrentStep] = useState(initialStep);

  console.log(initialStep)

  useEffect(() => {
    current > initialStep ? setCurrentStep(current) : setCurrentStep(initialStep) ;
  }, [initialStep, current]);

  return (
    <Box 
      sx={{ 
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >

      <Stepper
        alternativeLabel
        activeStep={currentStep}
        connector={<CustomConnector />}
        // sx={{ marginBottom: '0', justifyContent: 'center', width: '100%' }} // Ensure center alignment of steps
        sx={{
          width: '100%',
          padding: '0px',
          justifyContent: 'center',
          gap: '40px',
          '& .MuiStepLabel-root': {
            display: 'flex',
            flexDirection: 'column', 
            alignItems: 'center',   
            padding: 0,
          },
          '& .MuiStepLabel-labelContainer': {
            order: -1,               
          },
          '& .MuiStepLabel-iconContainer': {
            marginBottom: '8px',     
          },
        }}
        >
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={CustomStepIcon}>
              <Typography
                variant="body2"
                color={index === currentStep ? 'textPrimary' : 'textSecondary'}
                // sx={{ fontWeight: index === currentStep ? 'bold' : 'normal' }}
                style={{ fontFamily: 'Inter', fontSize: '12px', lineHeight: '30px', height: '30px', color: '#000000' }}
                sx={{ 
                  fontWeight: index === currentStep ? 'bold' : 'normal', 
                  fontSize: '11px',
                }}
              >
                Step {index + 1}
              </Typography>
              <Typography
                variant="caption"
                color={index === currentStep ? 'textPrimary' : 'textSecondary'}
                // sx={{ fontWeight: index === currentStep ? 'bold' : 'normal' }}
                style={{ fontFamily: 'Inter', fontSize: '10px', lineHeight: '11px', color: '#000000' }}
                sx={{ fontSize: '10px', lineHeight: '11px' }}
              >
                {step.label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

CustomStepWizard.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialStep: PropTypes.number,
};

export default CustomStepWizard;
